import { Icon } from '@iconify/react';
import { Box, ClickAwayListener, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';

const HelpTooltip = () => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Tooltip
      title={
        <Stack spacing={0.5}>
          <Typography variant="body2" fontWeight={700}>
            Если не нашли подходящую должность или специализацию
          </Typography>
          <Typography variant="body2">
            Выберите опцию "Другое" в поле "Сфера деятельности", затем укажите любую должность в поле
            "Должность".
          </Typography>
        </Stack>
      }
      open={tooltipOpen}
      arrow
      placement="top"
    >
      <Box>
        <ClickAwayListener
          onClickAway={() => {
            setTooltipOpen(false);
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: 40,
              color: 'text.disabled',
              cursor: 'help'
            }}
            onMouseEnter={() => (!isMobile ? setTooltipOpen(true) : null)}
            onMouseLeave={() => (!isMobile ? setTooltipOpen(false) : null)}
            onClick={() => {
              setTooltipOpen(true);
            }}
          >
            <Icon icon="mdi:help-circle-outline" width={22} height={22} />
          </Box>
        </ClickAwayListener>
      </Box>
    </Tooltip>
  );
};

export default HelpTooltip
